import { render, staticRenderFns } from "./createSuc.vue?vue&type=template&id=698484a8&scoped=true"
import script from "./createSuc.vue?vue&type=script&lang=js"
export * from "./createSuc.vue?vue&type=script&lang=js"
import style0 from "./createSuc.vue?vue&type=style&index=0&id=698484a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698484a8",
  null
  
)

export default component.exports